import { __extends, __assign, __makeTemplateObject, __rest } from 'tslib';
import React, { createRef, Component } from 'react';
import { styled } from 'styled-components';
import { getLogger } from '../../../utils/log/logger.js';
import ReactModal from 'react-modal';
import classnames from 'classnames';
import { baseStyles } from './Modal.baseStyles.js';
import { SuomifiThemeConsumer } from '../../theme/SuomifiThemeProvider/SuomifiThemeProvider.js';
import '../../theme/SuomifiTheme/SuomifiTheme.js';
import '../../theme/SpacingProvider/SpacingProvider.js';

var defaultProviderValue = {
  focusTitleOnOpen: true,
  titleRef: null,
  variant: 'default',
  scrollable: true
};
var _a = /*#__PURE__*/React.createContext(defaultProviderValue),
  ModalProvider = _a.Provider,
  ModalConsumer = _a.Consumer;
var baseClassName = 'fi-modal';
var modalClassNames = {
  smallScreen: "".concat(baseClassName, "--small-screen"),
  noScroll: "".concat(baseClassName, "--no-scroll"),
  overlay: "".concat(baseClassName, "_overlay"),
  base: "".concat(baseClassName, "_base"),
  contentContainer: "".concat(baseClassName, "_content-container")
};
var BaseModal = function (_super) {
  __extends(BaseModal, _super);
  function BaseModal(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      bodyScrollDisabled: false,
      scrollTop: 0,
      scrollLeft: 0
    };
    _this.titleRef = /*#__PURE__*/createRef();
    _this.toggleBodyScroll = function () {
      var _a, _b;
      if (!!document && !!document.body && !!document.scrollingElement) {
        if (_this.state.bodyScrollDisabled === true && document.body.hasAttribute('data-fi-modal')) {
          document.body.style.position = 'static';
          document.body.style.overflow = 'auto';
          document.scrollingElement.scrollTop = _this.state.scrollTop;
          document.scrollingElement.scrollLeft = _this.state.scrollLeft;
          document.body.removeAttribute('data-fi-modal');
          _this.setState({
            bodyScrollDisabled: false
          });
        } else if (!document.body.hasAttribute('data-fi-modal')) {
          document.body.setAttribute('data-fi-modal', '');
          var newState = {
            bodyScrollDisabled: true,
            scrollTop: (_a = document.scrollingElement) === null || _a === void 0 ? void 0 : _a.scrollTop,
            scrollLeft: (_b = document.scrollingElement) === null || _b === void 0 ? void 0 : _b.scrollLeft
          };
          _this.setState(newState);
          document.body.style.position = _this.props.variant === 'smallScreen' ? 'fixed' : 'sticky';
          document.body.style.overflow = 'hidden';
          if (!!newState.scrollTop && !!newState.scrollLeft) {
            document.scrollingElement.scrollTop = newState.scrollTop;
            document.scrollingElement.scrollLeft = newState.scrollLeft;
          }
        }
      }
    };
    if (props.appElementId) {
      ReactModal.setAppElement("#".concat(props.appElementId));
    }
    return _this;
  }
  BaseModal.prototype.render = function () {
    var _a;
    var _this = this;
    var _b = this.props,
      visible = _b.visible,
      style = _b.style,
      appElementId = _b.appElementId,
      propClassName = _b.propClassName,
      className = _b.className,
      children = _b.children,
      _c = _b.variant,
      variant = _c === void 0 ? 'default' : _c,
      _d = _b.scrollable,
      scrollable = _d === void 0 ? true : _d,
      focusOnOpenRef = _b.focusOnOpenRef,
      _e = _b.focusOnCloseRef,
      focusOnCloseRef = _e === void 0 ? null : _e,
      onEscKeyDown = _b.onEscKeyDown,
      ariaLabelledBy = _b.ariaLabelledBy;
    if (!appElementId) {
      getLogger().error("Invalid or missing appElementId.");
    }
    return /*#__PURE__*/React.createElement(ReactModal, __assign({
      portalClassName: classnames(className, modalClassNames.base),
      overlayClassName: classnames(modalClassNames.overlay),
      className: classnames(propClassName, baseClassName, (_a = {}, _a[modalClassNames.smallScreen] = variant === 'smallScreen', _a[modalClassNames.noScroll] = scrollable === false, _a)),
      ariaHideApp: !!appElementId,
      aria: {
        modal: false,
        labelledby: ariaLabelledBy
      },
      isOpen: visible,
      onAfterOpen: function onAfterOpen() {
        _this.toggleBodyScroll();
        if (!!focusOnOpenRef && !!focusOnOpenRef.current) {
          focusOnOpenRef.current.focus();
        } else if (!!_this.titleRef && !!_this.titleRef.current) {
          _this.titleRef.current.focus();
        }
      },
      onAfterClose: function onAfterClose() {
        _this.toggleBodyScroll();
        if (!!focusOnCloseRef && !!focusOnCloseRef.current) {
          focusOnCloseRef.current.focus();
        }
      },
      onRequestClose: function onRequestClose() {
        if (!!onEscKeyDown) onEscKeyDown();
      },
      shouldFocusAfterRender: true,
      shouldReturnFocusAfterClose: !focusOnCloseRef,
      shouldCloseOnOverlayClick: false,
      shouldCloseOnEsc: true
    }, !!style ? {
      style: {
        content: __assign({}, style)
      }
    } : {}), /*#__PURE__*/React.createElement(ModalProvider, {
      value: {
        focusTitleOnOpen: !focusOnOpenRef,
        titleRef: this.titleRef,
        variant: variant,
        scrollable: scrollable
      }
    }, children));
  };
  return BaseModal;
}(Component);
var StyledModal = styled(BaseModal).withConfig({
  componentId: "sc-138exhi-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return baseStyles(theme);
});
var Modal = function Modal(props) {
  var propClassName = props.className,
    passProps = __rest(props, ["className"]);
  return /*#__PURE__*/React.createElement(SuomifiThemeConsumer, null, function (_a) {
    var suomifiTheme = _a.suomifiTheme;
    return /*#__PURE__*/React.createElement(StyledModal, __assign({
      theme: suomifiTheme,
      propClassName: propClassName
    }, passProps));
  });
};
Modal.displayName = 'Modal';
var templateObject_1;

export { Modal, ModalConsumer, ModalProvider, baseClassName };
//# sourceMappingURL=Modal.js.map
